import { Link } from "react-router-dom";
import { Button, SubHeadingTitle } from "../../../../../components/shared";
import styles from "../myaddress.module.css";

const AddressList = ({ addressList, onDelete, onEdit }) => {
  return (
    <div className={styles.address__wrapper}>
      {addressList?.map((item) => (
        <div key={item.id} className={styles.card}>
          {/* ADDRESS INFORMATION */}
          <div className={styles.info}>
            <SubHeadingTitle
              subTitle={item?.name}
              style={styles.info__para}
            />

            <SubHeadingTitle
              subTitle={item?.phone}
              style={styles.info__para}
            />

            <SubHeadingTitle
              subTitle={`${item?.address}, ${item?.city}`}
              style={styles.info__para}
            />

            <SubHeadingTitle
              subTitle={item?.zip}
              style={styles.info__para}
            />
          </div>

          {/* ACTIONS */}
          <div className={styles.action}>
            <Link
              to="#"
              className={styles.editBtn}
              onClick={(e) => {
                e.preventDefault();
                onEdit(item);
              }}
            >
              Edit
            </Link>

            <span className={styles.separator}>|</span>

            <Button
              style={styles.deleteBtn}
              type="button"
              title="Remove"
              onHandler={() => onDelete(item?.id)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddressList;